import Button from '../components/button/button';
import Popup from '../components/popup/popup';
import ChangePassword from '../LogInSignUp/Components/ChangePassword';
import styles from './account.module.css';
import UserImg from './user.png';
import { memo, useContext, useEffect, useState } from 'react';
import success from '../icons/success.svg'
import { useNavigate } from 'react-router-dom';
import Input from '../components/input/input';
import { changeUserData } from '../services/api';
import { UserDataContext } from '../Context/Context';
import Loading from "../components/Loading/Loading";

const Account = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const [error, setError] = useState(false)
  const [userName, setUserName] = useState('user')
  const [email, setEmail] = useState('email')
  const [message, setMessage] = useState('')
  const { user, setUser } = useContext(UserDataContext);
  const navigate = useNavigate()

  useEffect(() => {
    setUserName(user.username)
    setEmail(user.email)
  }, [user, setUser])

  function changeState(message, visible, error) {
    setMessage(message)
    setIsPopupVisible(visible)
    setError(error)
  }
  async function setUserData() {
    const successChanged = await changeUserData(userName !== user.username ? userName : null, email !== user.email ? email : null)
    if (successChanged.ok) {
      setMessage(successChanged.message)
      setError(false)
      setUser({ username: userName, email: email, loggined: true })
    } else {
      setMessage(successChanged.message)
      setError(true)
    }
  }

  return (
    user.loggined ? <>
      <Popup visible={message?.length > 0} id={styles.message} hideLogo={true}>
        {!error && <img src={success} alt="success" style={{ width: '40px', height: "40px" }} />}
        <p style={{ textAlign: 'center', fontSize: '18px', marginTop: "20px", textTransform: "capitalize" }}> {message}</p>
        <Button onClick={() => changeState('', isPopupVisible, false)} style={{ marginTop: "40px", maxWidth: "350px" }}>Ok</Button>
      </Popup>
      <Popup hideLogo={true} visible={isPopupVisible} onClose={() => setIsPopupVisible(false)} closeBtn={true}>
        <ChangePassword changeState={changeState} from='user' />
      </Popup>
      {/* <Header /> */}
      <div className={styles.wrapper}>
        <h1>Welcome!</h1>
        <div className={styles.main}>
          <div className={styles.top_bg}></div>
          <div className={styles.content}>
            <div className={styles.info_wrapper}>
              <div className={styles.user_info}>
                <div className={styles.img}>
                  <img src={UserImg} alt="User" />
                </div>
                <div className={styles.name_email}>
                  <span className={styles.name}>{user.username}</span>
                  <span className={styles.email}>{user.email}</span>
                </div>
              </div>
              <Button onClick={() => setIsPopupVisible(true)} buttonType='whtBtn' >Change Password</Button>
            </div>
            <form >
              <div className={styles.user_name}>
                <Input
                  label="Username"
                  type="text"
                  value={userName}
                  style={!userName ? { border: '1px solid red' } : null}
                  onChange={(e) => setUserName(e.target.value)}
                  errText={!userName ? 'Wrong' : null}
                />
              </div>
              <div className={styles.user_name}>
                <Input
                  label="Email Address"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={(email?.length > 2 && (!email || !email.includes('@'))) ? { border: '1px solid red' } : null}
                  errText={!email.includes('@') && email?.length > 2 ? 'Please enter a valid email address.' : null}
                />
              </div>
            </form>
            <div style={{ display: 'flex', justifyContent: "center" }}>
              <Button style={{ width: "200px" }} onClick={() => setUserData()} disabled={!email.includes('@') || !userName || (email === user.email && userName === user.username)}>Save Changes</Button>
            </div>
            <div className={styles.bottomSection}>
              <Button style={{ width: "200PX", marginTop: "0" }} onClick={() => navigate('/support')}>Contact support</Button>
            </div>
          </div>
        </div>
      </div>
    </> : < Loading />
  );
};
export default memo(Account);